import { render, staticRenderFns } from "./audio-play.vue?vue&type=template&id=1abb5013&scoped=true&"
import script from "./audio-play.vue?vue&type=script&lang=js&"
export * from "./audio-play.vue?vue&type=script&lang=js&"
import style0 from "./audio-play.vue?vue&type=style&index=0&id=1abb5013&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb5013",
  null
  
)

export default component.exports